module.exports = __webpack_public_path__ + "img/2-zh.fc1ccf06.png";